import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TaskModel} from "../../../../tasks/models/task.model";
import * as _ from "lodash";
import * as moment from "moment";

require('./task-eta.scss');
@Component({
  standalone: false,
  selector: 'app-task-eta',
  templateUrl: './task-eta.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskEtaComponent implements OnInit, OnChanges {

  @Input() task: TaskModel;
  @Input() timeZoneId: string;
  @Input() configZoneId: string;

  public timeZoneOffsetDiff: any;
  public currentTime: number;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.timeZoneOffsetDiff = 0;
    this.checkTimeZoneOffsetDiff();
    this.currentTime = moment().valueOf();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.configZoneId && !changes.configZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
    if (changes.timeZoneId && !changes.timeZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
  }

  checkTimeZoneOffsetDiff() {
    this.timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(this.timeZoneId, _.get(this.task, 'taskSpec.externalEta') || _.get(this.task, 'analysis.eta'));
    return this.timeZoneOffsetDiff !== 0;
  }

}
